import React from 'react';
import { useTranslation } from "react-i18next";
import { useDroppable } from '@dnd-kit/core';

const FramePlacementSlotRenderer = ({ slot, scale, onClick }) => {
    const { t } = useTranslation();
    const { x, y, rotation, width, height } = slot;

    const { isOver, setNodeRef } = useDroppable({
        id: `slot-${slot.id}`,
        data: { slot },
    });

    const slotWidthPx = width * scale;
    const slotHeightPx = height * scale;

    const transform = `translate(${x * scale}, ${y * scale}) rotate(${rotation || 0})`;

    const fontSize = Math.max(12, 0.3 * scale);

    const textTransform = `rotate(${-rotation || 0}, ${slotWidthPx / 2}, ${slotHeightPx / 2})`;

    // Highlight when dragging over
    const rectStyle = {
        fill: isOver ? 'rgba(52, 211, 153, 0.35)' : 'rgba(52, 211, 153, 0.25)',
        stroke: isOver ? 'rgba(5, 150, 105, 1)' : 'rgba(5, 150, 105, 0.9)',
        transition: 'fill 0.2s ease, stroke 0.2s ease',
    };

    const textFill = '#059669';

    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onClick) {
            onClick(slot);
        }
    };

    return (
        <g
            ref={setNodeRef}
            transform={transform}
            className="cursor-pointer group"
            onClick={handleClick}
        >
            <rect
                x={0}
                y={0}
                width={slotWidthPx}
                height={slotHeightPx}
                strokeWidth={Math.max(1.5, 0.03 * scale)}
                rx={Math.max(4, 0.08 * scale)}
                strokeDasharray="4, 4"
                className="transition-all duration-150"
                style={rectStyle}
            />
            <text
                x={slotWidthPx / 2}
                y={slotHeightPx / 2}
                fill={textFill}
                fontSize={fontSize}
                fontWeight="500"
                textAnchor="middle"
                dominantBaseline="middle"
                pointerEvents="none"
                className="select-none transition-colors"
                transform={textTransform}
            >
                {t('renderers.addHere')}
            </text>
        </g>
    );
};

export default React.memo(FramePlacementSlotRenderer);
